<div class="flex w-full flex-col gap-y-6">
  <ng-container *ngTemplateOutlet="snackBarRow; context: {
    type: 'default',
    message: 'Default snack bar',
    backgroundClass: 'bg-[--mx-snack-bar-default-background-color]',
    textClass: 'text-[--mx-snack-bar-default-text-color]',
    actionClass: 'text-[--mx-snack-bar-default-action-color]'
  }"/>

  <ng-container *ngTemplateOutlet="snackBarRow; context: {
    type: 'success',
    message: 'Success snack bar',
    backgroundClass: 'bg-[--mx-snack-bar-success-background-color]',
    textClass: 'text-[--mx-snack-bar-success-text-color]',
    actionClass: 'text-[--mx-snack-bar-success-action-color]'
  }"/>

  <ng-container *ngTemplateOutlet="snackBarRow; context: {
    type: 'error',
    message: 'Error snack bar',
    backgroundClass: 'bg-[--mx-snack-bar-error-background-color]',
    textClass: 'text-[--mx-snack-bar-error-text-color]',
    actionClass: 'text-[--mx-snack-bar-error-action-color]'
  }"/>

  <div class="flex flex-wrap justify-center gap-6">
    <mx-elevated-button label="Test Centered Multiline Success" (click)="showCenteredMultiline('success')"/>
    <mx-elevated-button label="Test Centered Multiline Error" (click)="showCenteredMultiline('error')"/>
  </div>
</div>

<ng-template #snackBarRow let-type="type" let-message="message" let-backgroundClass="backgroundClass" let-textClass="textClass" let-actionClass="actionClass">
  <div class="flex w-full flex-col justify-center gap-6 lg:flex-row lg:gap-x-12">
    <ng-container *ngTemplateOutlet="snackBarExample; context: {
      type: type, message: message, backgroundClass: backgroundClass, textClass: textClass, actionClass: actionClass, withAction: false
    }"/>

    <ng-container *ngTemplateOutlet="snackBarExample; context: {
      type: type, message: message, backgroundClass: backgroundClass, textClass: textClass, actionClass: actionClass, withAction: true
    }"/>
  </div>
</ng-template>

<ng-template #snackBarExample let-type="type" let-message="message" let-backgroundClass="backgroundClass" let-textClass="textClass"
             let-actionClass="actionClass" let-withAction="withAction">
  <div class="flex min-w-0 flex-1 items-center gap-x-4">
    <div class="flex min-h-12 min-w-0 flex-1 items-center justify-between rounded px-4 py-3 text-body-large shadow-md sm:min-w-[16rem]"
         [ngClass]="[backgroundClass, textClass]">
      <span>{{ message }}</span>

      @if (withAction) {
        <span class="ml-4 font-medium" [ngClass]="actionClass">ACTION</span>
      }
    </div>

    <mx-elevated-button label="Test" (click)="show(type, withAction)"/>
  </div>
</ng-template>
